/**
 * Bounded scan for large tool payloads (e.g. full project JSON) without
 * {@link JSON.stringify} on whole value — that would freeze the main thread.
 */
export function isHeavyJsonValue(value: unknown): boolean {
  const stack: { v: unknown; d: number }[] = [{ v: value, d: 0 }];
  let steps = 0;
  const MAX_STEPS = 8_000;
  const MAX_DEPTH = 14;

  while (stack.length) {
    if (steps >= MAX_STEPS) return true;
    const item = stack.pop()!;
    const { v, d } = item;
    steps++;
    if (d > MAX_DEPTH) return true;
    if (v == null || typeof v === 'boolean' || typeof v === 'number') {
      continue;
    }
    if (typeof v === 'string') {
      if (v.length > 80_000) return true;
      continue;
    }
    if (Array.isArray(v)) {
      if (v.length > 1_500) return true;
      const cap = Math.min(v.length, 500);
      for (let i = 0; i < cap; i++) {
        stack.push({ v: v[i], d: d + 1 });
      }
      if (v.length > cap) return true;
      continue;
    }
    const keys = Object.keys(v as object);
    if (keys.length > 400) return true;
    for (const k of keys) {
      stack.push({
        v: (v as Record<string, unknown>)[k],
        d: d + 1,
      });
    }
  }
  return false;
}
